import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {ObservableBackendService} from "./observableBackend.service";
import {Vehicle} from "../domain/vehicle";
import {Page} from "../domain/page";
import {URLSearchParams} from "@angular/http";
import {KmHistory} from "../domain/kmHistory";

@Injectable()
export class KmHistoryService {

    constructor(private backendService: ObservableBackendService) {
    }

    public findKmHistory(filter: Vehicle, page: number, itemsPerPage: number): Observable<Page> {
        let params = new URLSearchParams();
        if (filter.patent) {
            params.set('patent', filter.patent);
        }
        if (filter.contract.bank && filter.contract.bank.id) {
            params.set('contract.bank.id', filter.contract.bank.id);
        }
        if (filter.contract.contractNumber) {
            params.set('contract.contractNumber', filter.contract.contractNumber);
        }
        if (filter.contract.cuit) {
            params.set('contract.cuit', filter.contract.cuit);
        }
        if (filter.kmHistories.length > 0) {
            if (filter.kmHistories[0].loadDateSince && filter.kmHistories[0].loadDateUntil) {
                params.set('kmHistories[0].loadDateSince', filter.kmHistories[0].loadDateSince);
                params.set('kmHistories[0].loadDateUntil', filter.kmHistories[0].loadDateUntil);
            }
        }

        params.set('length', String(itemsPerPage));
        params.set('pageNumber', String(page));
        return this.backendService.get("km_histories", params);
    }

    public getVehicle(vehicleId: string): Observable<Vehicle> {
        return this.backendService.get("vehicle/" + vehicleId + "/kmHistory ", null);
    }

    public save(vehicle: Vehicle): Observable<Vehicle> {
        return this.backendService.post("vehicle/kmHistory", vehicle, null);
    }

    public static getURLKmHistoryBulkload(documentId: string): string {
        return "/kmHistoriesBulkloadDocument/" + documentId;
    }

    public delete(kmHistoryId: string): Observable<KmHistory> {
        return this.backendService.delete("kmHistory/" + kmHistoryId, null, null);
    }

    private static setParams(filter: Vehicle, page: number, itemsPerPage: number): URLSearchParams {
        let params = new URLSearchParams();
        if (filter.patent) {
            params.set('patent', filter.patent);
        }
        if (filter.contract.bank && filter.contract.bank.id) {
            params.set('contract.bank.id', filter.contract.bank.id);
        }
        if (filter.contract.contractNumber) {
            params.set('contract.contractNumber', filter.contract.contractNumber);
        }
        if (filter.contract.cuit) {
            params.set('contract.cuit', filter.contract.cuit);
        }
        if (filter.kmHistories.length > 0) {
            if (filter.kmHistories[0].loadDateSince && filter.kmHistories[0].loadDateUntil) {
                params.set('kmHistories[0].loadDateSince', filter.kmHistories[0].loadDateSince);
                params.set('kmHistories[0].loadDateUntil', filter.kmHistories[0].loadDateUntil);
            }
        }

        params.set('length', String(itemsPerPage));
        params.set('pageNumber', String(page));
        return params;
    }

    public static getURLFilterKmHistories(filter: Vehicle, page: number, itemsPerPage: number): string {
        return "/kmHistoriesReport?" + KmHistoryService.setParams(filter, page, itemsPerPage).toString();
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/service/kmHistory.service.ts
 **/